import Carousel from "react-bootstrap/Carousel";

function UncontrolledExample() {
  return (
    <Carousel
      className="slider"
    //   style={{
    //     width: "280px",
    //     height: "15%",
    //     background: "#ee344e",
    //     paddingLeft: "15px",
    //     paddingRight: "15px",
    //     justifyContent: "center",
    //     color: "#ffff",
    //   }}
    >
      <Carousel.Item>
        <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12 d-block w-100">
          <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
            <div className="themetechmount-post-item">
              <div className="themetechmount-box-content">
                <div className="themetechmount-box-author">
                  <div className="themetechmount-box-desc">
                    <blockquote className="themetechmount-testimonial-text">
                      As a breeder of exotic animals &amp; as the editor a it
                      has been a pleasure getting to know the owners of WildDale
                      I just like the way they were taking care!
                    </blockquote>
                    <div className="themetechmount-ratting-star">
                      {" "}
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                    </div>
                  </div>
                  <div className="tm-box-footer tm-wrap">
                    <div className="themetechmount-box-img tm-wrap-cell">
                      <span className="themetechmount-item-thumbnail">
                        <span className="themetechmount-item-thumbnail-inner">
                          <img
                            width={150}
                            height={150}
                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-1-150x150.jpg"
                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-1-150x150.jpg"
                            className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                            alt=""
                            data-id={6140}
                          />
                        </span>
                      </span>{" "}
                    </div>
                    <div className="themetechmount-box-title tm-wrap-cell">
                      <span className="themetechmount-box-footer">Tourist</span>
                      <h3 className="themetechmount-author-name">
                        Victor Williamson
                      </h3>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12 d-block w-100">
          <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
            <div className="themetechmount-post-item">
              <div className="themetechmount-box-content">
                <div className="themetechmount-box-author">
                  <div className="themetechmount-box-desc">
                    <blockquote className="themetechmount-testimonial-text">
                      It has been a pleasure to visit WildDale. Here, display
                      some of the animals that were born on my farm because I
                      appreciate the facility &amp; the care !
                    </blockquote>
                    <div className="themetechmount-ratting-star">
                      {" "}
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                      <i className="fa-sharp fa-solid fa-star"></i>
                    </div>
                  </div>
                  <div className="tm-box-footer tm-wrap">
                    <div className="themetechmount-box-img tm-wrap-cell">
                      <span className="themetechmount-item-thumbnail">
                        <span className="themetechmount-item-thumbnail-inner">
                          <img
                            width={150}
                            height={150}
                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-2-150x150.jpg"
                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-2-150x150.jpg"
                            className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                            alt=""
                            data-id={6141}
                          />
                        </span>
                      </span>{" "}
                    </div>
                    <div className="themetechmount-box-title tm-wrap-cell">
                      <span className="themetechmount-box-footer">
                        Zoo Visitors
                      </span>
                      <h3 className="themetechmount-author-name">
                        Elinn Edward
                      </h3>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
          <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12 d-block w-100">
            <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
              <div className="themetechmount-post-item">
                <div className="themetechmount-box-content">
                  <div className="themetechmount-box-author">
                    <div className="themetechmount-box-desc">
                      <blockquote className="themetechmount-testimonial-text">
                        A fantastic experience for kids &amp; adults alike! We
                        will certainly be back soon to see how our new
                        friends-mate have grown &amp; take more pictures.
                      </blockquote>
                      <div className="themetechmount-ratting-star">
                        {" "}
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                      </div>
                    </div>
                    <div className="tm-box-footer tm-wrap">
                      <div className="themetechmount-box-img tm-wrap-cell">
                        <span className="themetechmount-item-thumbnail">
                          <span className="themetechmount-item-thumbnail-inner">
                            <img
                              width={150}
                              height={150}
                              src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-3-150x150.jpg"
                              data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-3-150x150.jpg"
                              className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                              alt=""
                              data-id={6142}
                            />
                          </span>
                        </span>{" "}
                      </div>
                      <div className="themetechmount-box-title tm-wrap-cell">
                        <span className="themetechmount-box-footer">
                          Zoo visitors
                        </span>
                        <h3 className="themetechmount-author-name">
                          Sania Williamson
                        </h3>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default UncontrolledExample;
